export function raitingStars() {

    let raiting = $("[data-raiting]").attr("data-raiting");
    let activeKoef = 20;

    if (raiting) {
        $(".raiting-active").css({
            width: Number(raiting) * activeKoef + "%"
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/raitingStars.js